// About.jsx
import React from 'react';
import { motion } from 'framer-motion';
import aboutImage from '../assets/aboutImage.jpg';
import { FaReact, FaNodeJs, FaAws } from 'react-icons/fa';

const About = () => {
  return (
    <motion.div
      id="about"
      className="about"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {/* Left Column - Image */}
      <motion.div
        className="about-image"
        initial={{ x: '-100vw' }}
        animate={{ x: 0 }}
        transition={{ type: 'spring', stiffness: 50 }}
      >
        <img src={aboutImage} alt="About" className="about-img" />
      </motion.div>

      {/* Right Column - Text */}
      <motion.div
        className="about-text"
        initial={{ x: '100vw' }}
        animate={{ x: 0 }}
        transition={{ type: 'spring', stiffness: 50 }}
      >
        <h2 className="about-title">Software Engineer</h2>
        <p className="about-description">
          Hi, I’m Bhagya. I specialize in designing and building interactive, responsive, and visually
          appealing web applications that solve real-world challenges.
        </p>
        <p className="about-description">
          My expertise lies in leveraging modern web technologies to craft seamless user experiences.
        </p>

        {/* Highlighted Skills */}
        <div className="about-skills">
          <motion.div
            whileHover={{ scale: 1.1 }}
            className="skill-card react"
          >
            <FaReact size={24} className="skill-icon" />
            React
          </motion.div>
          <motion.div
            whileHover={{ scale: 1.1 }}
            className="skill-card nodejs"
          >
            <FaNodeJs size={24} className="skill-icon" />
            Node.js
          </motion.div>
          <motion.div
            whileHover={{ scale: 1.1 }}
            className="skill-card aws"
          >
            <FaAws size={24} className="skill-icon" />
            AWS
          </motion.div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default About;
